import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ContactSocketPage } from './contact-socket';

@NgModule({
  declarations: [
    ContactSocketPage,
  ],
  imports: [
    IonicPageModule.forChild(ContactSocketPage),
  ],
})
export class ContactSocketPageModule {}



// WEBPACK FOOTER //
// ./src/pages/contact-socket/contact-socket.module.ts